import * as React from "react";
import { Logo } from "../brand/Logo";

/**
 * The Grackle lockup (Boswell + wordmark) sized like a line of text. A thin wrapper over `Logo` kept
 * for existing callers; new code should use `Logo` directly. The wordmark is artwork, never
 * re-typeset in Hind.
 */
export interface WordmarkProps {
  /** Height in px of the lockup. Default 23 */
  size?: number;
  /** Show Boswell (the logomark). false renders the wordmark alone. Default true */
  mark?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export function Wordmark({ size = 23, mark = true, className, style }: WordmarkProps): JSX.Element {
  return (
    <span className={["gk-wordmark", className].filter(Boolean).join(" ")} style={style}>
      <Logo variant={mark ? "lockup" : "wordmark"} height={Math.max(20, size)} />
    </span>
  );
}
